module.exports = __webpack_public_path__ + "img/lipigo_2.0e0fec58.png";